module.exports = __webpack_public_path__ + "static/media/exit-question.88ca3a79.svg";